import type { ReactNode } from 'react';

export const symbol_pin_road_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M548-120v-143h60v143h-60Zm0-289v-143h60v143h-60Zm0-289v-142h60v142h-60Zm272 578L711-840h59l110 720h-60Zm-581.5-3.5Q233-127 230-132l-4-9.16Q204-190 163-223.5t-70-78.16Q77-325 69-352q-8-27-8-56 0-79 54.73-135 54.72-56 132.27-56 79 0 136 52.5T441-416q0 31-8.5 59.5T407.11-302q-28.81 44-69.55 78.5-40.73 34.5-63.59 82.5l-3.97 9q-3 5-8.5 8.5T250-120q-6 0-11.5-3.5Zm69-230Q331-377 331-410t-23.5-56.5Q284-490 251-490t-56.5 23.5Q171-443 171-410t23.5 56.5Q218-330 251-330t56.5-23.5ZM410-605q-13-11-26.5-19.08Q370-632.16 355-639l31-201h60l-36 235Z"
		/>
	</svg>
);
